var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"helper-bg",class:_vm.$route.path.includes('forgot') ? '--surpress' : ''},[_c('img',{attrs:{"src":"data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==","alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }